import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useTheme } from "../../contexts/ThemeContext";
import { monoInk } from "../../lib/mono";

export const Contact = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const { ink, muted, chip } = monoInk(isDark);

  const methods = [
    {
      id: "email",
      label: t("contact.email.label"),
      sublabel: "charcrith@gmail.com",
      href: "mailto:charcrith@gmail.com",
      cta: t("contact.email.cta"),
    },
    {
      id: "github",
      label: t("contact.github.label"),
      sublabel: "@Charcrith",
      href: "https://github.com/Charcrith",
      cta: t("contact.github.cta"),
    },
  ];

  return (
    <section
      id="contact"
      className={[
        "apple-tile",
        isDark ? "apple-tile-raise" : "apple-tile-parchment",
      ].join(" ")}
    >
      <div className="max-w-[680px] mx-auto text-center space-y-8 sm:space-y-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.55 }}
          className="space-y-3 sm:space-y-4"
        >
          <h2 className="apple-title" style={{ color: ink }}>
            {t("contact.title1")}
            <br />
            {t("contact.title2")}
          </h2>
          <p className="apple-body max-w-md mx-auto" style={{ color: muted }}>
            {t("contact.desc")}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.55, delay: 0.08 }}
          className="space-y-2"
        >
          <p
            className="text-[12px] uppercase tracking-[0.12em] mb-3 sm:mb-4"
            style={{ color: muted }}
          >
            {t("contact.reach")}
          </p>
          {methods.map((m) => (
            <a
              key={m.id}
              href={m.href}
              target={m.id === "github" ? "_blank" : undefined}
              rel={m.id === "github" ? "noopener noreferrer" : undefined}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 px-4 sm:px-5 py-4 rounded-[14px] sm:rounded-[18px] transition-opacity hover:opacity-90 text-left"
              style={{
                background: isDark ? "rgba(255,255,255,0.06)" : chip,
              }}
            >
              <div className="min-w-0">
                <p
                  className="text-[16px] sm:text-[17px] font-semibold"
                  style={{ color: ink }}
                >
                  {m.label}
                </p>
                <p
                  className="text-[13px] sm:text-[14px] truncate"
                  style={{ color: muted }}
                >
                  {m.sublabel}
                </p>
              </div>
              <span
                className="text-[13px] sm:text-[14px] shrink-0"
                style={{ color: ink }}
              >
                {m.cta}
              </span>
            </a>
          ))}
        </motion.div>

        <p
          className="inline-flex items-start sm:items-center justify-center gap-2 text-[13px] sm:text-[14px] max-w-sm mx-auto leading-relaxed px-2"
          style={{ color: muted }}
        >
          <FaMapMarkerAlt
            className="w-3.5 h-3.5 shrink-0 mt-0.5 sm:mt-0"
            aria-hidden
          />
          <span>{t("contact.location")}</span>
        </p>
      </div>
    </section>
  );
};
